export const translationOrganizations_en_part2 = {
  orgDetailKnowledgeBaseIndexesMustBeArray: "Knowledge base indexes must be a JSON array.",
  orgDetailSettingsSaved: "Organization settings saved.",
  orgDetailUnableToSaveSettings: "Unable to save organization settings.",
  orgDetailChatbotAttached: "Attached {chatbotId} to this organization.",
  orgDetailChatbotDetached: "Detached {chatbotId} from this organization.",
  orgDetailPaymentEventAdded: "Payment event added.",
  orgDetailPaymentEventSaved: "Payment event saved.",
  orgDetailUnableToSavePaymentEvent: "Unable to save payment event.",
  orgDetailDeletePaymentEventTitle: "Delete this payment event?",
  orgDetailPaymentEventDeleted: "Payment event deleted.",
  orgDetailUnableToDeletePaymentEvent: "Unable to delete payment event.",
  orgDetailInviteRoleTitle: "Invite organization {role}?",
  orgDetailInviteRoleWarning:
    "You are about to give {role} access in this organization to {email}. {description} Continue?",
  orgDetailThisEmail: "this email",
  orgDetailSendInvite: "Send invite",
  orgDetailInvitationSent: "Invitation sent.",
  orgDetailUnableToSendInvitation: "Unable to send invitation.",
  orgDetailInvitationResent: "Invitation resent.",
  orgDetailUnableToResendInvitation: "Unable to resend invitation.",
  orgDetailInvitationCancelled: "Invitation cancelled.",
  orgDetailUnableToCancelInvitation: "Unable to cancel invitation.",
  orgDetailCannotChangeOwnRole: "You cannot change your own role.",
  orgDetailMemberRoleUpdated: "Member role updated.",
  orgDetailUnableToUpdateMemberRole: "Unable to update member role.",
  orgDetailCannotRemoveSelf: "You cannot remove yourself from this organization.",
  orgDetailRemoveMemberTitle: "Remove this member?",
  orgDetailRemoveMemberWarning:
    "Remove this member from the organization? Their user account will stay active and may still belong to other organizations.",
  orgDetailMemberRemoved: "Member removed.",
  orgDetailUnableToRemoveMember: "Unable to remove member.",
  orgDetailCannotDeleteOwnAccount: "You cannot delete your own account.",
  orgDetailDeleteUserTitle: "Delete this user account?",
  orgDetailDeleteUserWarning:
    "Permanently delete this user from the identity system? This removes all organization access and cannot be undone. Matched local dashboard data will be kept.",
  orgDetailDeleteUserConfirmLabel: "Delete user",
  orgDetailUserDeleted: "User deleted.",
  orgDetailUnableToDeleteUser: "Unable to delete user.",
  orgDetailMembersTitle: "Members",
  orgDetailMembersDescription:
    "Assign Member, Manager, Developer, Support, or Analyst to control which pages a member can use.",
  orgDetailMembersAdminNote: "Admins can also assign or clear Owner and permanently delete users.",
  orgDetailOwnerAccessLockedNote: "Owner access cannot be changed here.",
  orgDetailOwnerAccessLocked: "Owner access cannot be changed here",
  orgDetailMembersCount: "{count} members",
  orgDetailNoMembersFound: "No members found in this organization.",
  orgDetailTableMember: "Member",
  orgDetailTableEmail: "Email",
  orgDetailTableRole: "Role",
  orgDetailTableAccess: "Access",
  orgDetailTableActions: "Actions",
  orgDetailNoEmailAvailable: "No email available",
  orgDetailSelfLockNotice:
    "You cannot change your own role, remove yourself, or delete your own account",
  orgDetailRemoveTooltip: "Remove from this organization",
  orgDetailDeleteUser: "Delete User",
  orgDetailDeleteUserTooltip: "Delete this user account",
  orgDetailInviteTeamMember: "Invite Team Member",
  orgDetailInviteDescription:
    "Invitations with a role other than Member require confirmation before the invite is sent.",
  orgDetailEmailLabel: "Email",
  orgDetailFirstNameLabel: "First Name",
  orgDetailFirstNamePlaceholder: "First name",
  orgDetailLastNameLabel: "Last Name",
  orgDetailLastNamePlaceholder: "Last name",
  orgDetailRoleLabel: "Role",
  orgDetailSending: "Sending...",
  orgDetailSendInvitation: "Send Invitation",
  orgDetailInvitationsTitle: "Invitations",
  orgDetailNoInvitationsFound: "No invitations found.",
  orgDetailExpired: "Expired",
  orgDetailExpiresInHourSingular: "Expires in {hours} hour",
  orgDetailExpiresInHoursPlural: "Expires in {hours} hours",
  orgDetailBusinessTitle: "Business",
  orgDetailBusinessDescription:
    "Track monthly recurring revenue through dated increases, decreases, and churn.",
  orgDetailCurrentMonthlyPayment: "Current monthly payment",
  orgDetailEditPaymentEvent: "Edit payment event",
  orgDetailAddPaymentEvent: "Add payment event",
  orgDetailAmountDeltaLabel: "Amount delta (kr)",
  orgDetailAmountDeltaPlaceholder: "Use negative values for reductions",
  orgDetailEventDateLabel: "Event date",
  orgDetailNoteLabel: "Note",
  orgDetailNotePlaceholder: "Contract change, churn reason, discount, etc.",
  orgDetailCancelEdit: "Cancel Edit",
  orgDetailSaveEvent: "Save Event",
  orgDetailAddEvent: "Add Event",
  orgDetailPaymentEventsTitle: "Payment events",
  orgDetailNoPaymentEvents: "No payment events recorded.",
  orgDetailEventTypeChurn: "Churn",
  orgDetailEventTypeDecrease: "Decrease",
  orgDetailEventTypeIncrease: "Increase",
  orgDetailPaymentAfterEvent: "Payment after event: {amount}",
  orgDetailSettingsTitle: "Organization Settings",
  orgDetailSettingsDescription:
    "Realm admins can update organization-scoped settings here. These values are stored on the organization instead of on an individual user.",
  orgDetailDangerZoneTitle: "Danger zone",
  orgDetailDangerZoneDescription:
    "Deleting the organization removes it from Keycloak and permanently deletes all attached chatbots.",
  orgDetailDeleteOrganization: "Delete organization",
  orgDetailDeletingOrganization: "Deleting organization...",
  orgDetailDeleteOrganizationSummary:
    '"{name}" has {count} attached chatbot(s). This action cannot be undone.',
  orgDetailDeleteOrganizationTitle: 'Delete organization "{name}"?',
  orgDetailDeleteOrganizationWarning:
    'Organization "{name}" and its {count} attached chatbot(s) ({chatbots}) will be permanently deleted. Member accounts will not be deleted.',
  orgDetailDeleteOrganizationNoChatbots: "none",
};
